export const Shapes = () => (
  <svg
    width="336"
    height="72"
    viewBox="0 0 336 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.5">
      <g clipPath="url(#clip0_13782_53509)">
        <mask
          id="mask0_13782_53509"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="-1"
          y="-24"
          width="97"
          height="96"
        >
          <path d="M95.9921 -24H-0.0078125V72H95.9921V-24Z" fill="white" />
        </mask>
        <g mask="url(#mask0_13782_53509)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M-0.00664899 72C-0.00742407 71.9203 -0.0078125 71.8402 -0.0078125 71.76C-0.0078125 59.5733 8.98575 49.4866 20.698 47.7758C9.00182 46.1702 -0.0078125 36.1373 -0.0078125 24C-0.0078125 10.7452 10.7374 1.90735e-06 23.9922 1.90735e-06H24.2322C10.9249 1.90735e-06 0.122132 -10.7232 -0.00664899 -24H95.9911C95.862 -10.7232 85.0596 1.90735e-06 71.7521 1.90735e-06H71.9921C85.2468 1.90735e-06 95.9921 10.7452 95.9921 24C95.9921 36.1373 86.9825 46.1702 75.2863 47.7758C86.9983 49.4866 95.9921 59.5733 95.9921 71.76C95.9921 71.8402 95.9916 71.9203 95.9911 72H-0.00664899Z"
            fill="#FFC107"
          />
        </g>
      </g>
      <g clipPath="url(#clip1_13782_53509)">
        <mask
          id="mask1_13782_53509"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="120"
          y="-24"
          width="96"
          height="96"
        >
          <path d="M216 -24H120V72H216V-24Z" fill="white" />
        </mask>
        <g mask="url(#mask1_13782_53509)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M168 -24H120L168 24H120L168 72H216L168 24H216L168 -24Z"
            fill="#00C0C4"
          />
        </g>
      </g>
      <g clipPath="url(#clip2_13782_53509)">
        <mask
          id="mask2_13782_53509"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="240"
          y="-24"
          width="97"
          height="96"
        >
          <path d="M336.008 -24H240.008V72H336.008V-24Z" fill="white" />
        </mask>
        <g mask="url(#mask2_13782_53509)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M336.008 1.90735e-06V-24L288.008 -24V-0.00945282C288.003 -13.26 277.259 -24 264.008 -24H240.008V24H264.008C250.753 24 240.008 34.7453 240.008 48L240.008 72H288.008V48C288.008 61.2547 298.753 72 312.008 72H336.008V24H312.017C325.268 23.9949 336.008 13.2517 336.008 1.90735e-06Z"
            fill="#97CC04"
          />
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_13782_53509">
        <rect
          width="95.9999"
          height="96"
          fill="white"
          transform="translate(0 -24)"
        />
      </clipPath>
      <clipPath id="clip1_13782_53509">
        <rect
          width="95.9999"
          height="96"
          fill="white"
          transform="translate(120 -24)"
        />
      </clipPath>
      <clipPath id="clip2_13782_53509">
        <rect
          width="95.9999"
          height="96"
          fill="white"
          transform="translate(240 -24)"
        />
      </clipPath>
    </defs>
  </svg>
)
